import { render, staticRenderFns } from "./wxLogin.vue?vue&type=template&id=28a116f8&scoped=true&"
import script from "./wxLogin.vue?vue&type=script&lang=js&"
export * from "./wxLogin.vue?vue&type=script&lang=js&"
import style0 from "./wxLogin.vue?vue&type=style&index=0&id=28a116f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a116f8",
  null
  
)

export default component.exports